import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    GREENHOUSE_DEPARTMENTS_QUERY,
    SINGLE_GREENHOUSE_DEPARTMENT_QUERY,
    CREATE_GREENHOUSE_DEPARTMENT_MUTATION,
    UPDATE_GREENHOUSE_DEPARTMENT_MUTATION,
    DELETE_GREENHOUSE_DEPARTMENT_MUTATION
} from "@/graphql/greenhouseDepartments.js";

const state = {
    greenhouseDepartments: []
};

const getters = {};

const mutations = {
    [types.SET_GREENHOUSE_DEPARTMENTS](state, greenhouseDepartments) {
        state.greenhouseDepartments = greenhouseDepartments;
    },
    [types.SORT_GREENHOUSE_DEPARTMENTS](state) {
        state.greenhouseDepartments.sort(function(a, b) {
            // first sort by greenhouse name, then sort by department name
            if (a.node.greenhouse.id == b.node.greenhouse.id) {
                return a.node.name.toLowerCase() == b.node.name.toLowerCase()
                    ? 0
                    : a.node.name.toLowerCase() > b.node.name.toLowerCase()
                    ? 1
                    : -1;
            } else {
                return a.node.greenhouse.name.toLowerCase() ==
                    b.node.greenhouse.name.toLowerCase()
                    ? 0
                    : a.node.greenhouse.name.toLowerCase() >
                      b.node.greenhouse.name.toLowerCase()
                    ? 1
                    : -1;
            }
        });
    },
    [types.UPSERT_GREENHOUSE_DEPARTMENT](state, greenhouseDepartment) {
        var index = state.greenhouseDepartments.findIndex(function(element) {
            return element.node.id == greenhouseDepartment.id;
        });

        const node = { node: greenhouseDepartment };

        if (index > -1) {
            state.greenhouseDepartments.splice(index, 1, node);
        } else {
            state.greenhouseDepartments.unshift(node);
        }
    },
    [types.DELETE_GREENHOUSE_DEPARTMENT](state, greenhouseDepartment) {
        var index = state.greenhouseDepartments.find(function(element, index) {
            if (element.id == greenhouseDepartment.id) {
                return index;
            }
        });

        if (index > -1) {
            state.greenhouseDepartments.splice(index, 1);
        }
    }
};

const actions = {
    async fetchGreenhouseDepartments(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: GREENHOUSE_DEPARTMENTS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    // console.log(response);

                    // Option 1: if need extra calculate for each node, use this option
                    // const greenhouseDepartments = response.data.greenhouseDepartments.edges.map(
                    //     item => {
                    //         return {
                    //             node: item.node
                    //         };
                    //     }
                    // );

                    // Option 2
                    const greenhouseDepartments =
                        response.data.greenhouseDepartments.edges;

                    // set
                    context.commit(
                        types.SET_GREENHOUSE_DEPARTMENTS,
                        greenhouseDepartments
                    );

                    // sort
                    context.commit(types.SORT_GREENHOUSE_DEPARTMENTS);

                    resolve(greenhouseDepartments);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleGreenhouseDepartment(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_GREENHOUSE_DEPARTMENT_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouseDepartment = JSON.parse(
                        JSON.stringify(response.data.greenhouseDepartment)
                    );

                    // update store
                    context.commit(
                        types.UPSERT_GREENHOUSE_DEPARTMENT,
                        greenhouseDepartment
                    );

                    // sort
                    context.commit(types.SORT_GREENHOUSE_DEPARTMENTS);

                    resolve(greenhouseDepartment);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createGreenhouseDepartment(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_GREENHOUSE_DEPARTMENT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouseDepartment =
                        response.data.createGreenhouseDepartment
                            .greenhouseDepartment;

                    // update store
                    context.commit(
                        types.UPSERT_GREENHOUSE_DEPARTMENT,
                        greenhouseDepartment
                    );

                    // sort
                    context.commit(types.SORT_GREENHOUSE_DEPARTMENTS);

                    resolve(greenhouseDepartment);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateGreenhouseDepartment(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_GREENHOUSE_DEPARTMENT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouseDepartment =
                        response.data.updateGreenhouseDepartment
                            .greenhouseDepartment;

                    // update store
                    context.commit(
                        types.UPSERT_GREENHOUSE_DEPARTMENT,
                        greenhouseDepartment
                    );

                    // sort
                    context.commit(types.SORT_GREENHOUSE_DEPARTMENTS);

                    resolve(greenhouseDepartment);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteGreenhouseDepartment(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_GREENHOUSE_DEPARTMENT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouseDepartment =
                        response.data.deleteGreenhouseDepartment
                            .greenhouseDepartment;

                    // delete
                    context.commit(
                        types.DELETE_GREENHOUSE_DEPARTMENT,
                        greenhouseDepartment
                    );

                    resolve(greenhouseDepartment);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
